import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=d0527dd4&scoped=true&"
import script from "./Wallet.vue?vue&type=script&lang=ts&"
export * from "./Wallet.vue?vue&type=script&lang=ts&"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=d0527dd4&prod&scoped=true&lang=scss&"
import style1 from "./Wallet.vue?vue&type=style&index=1&id=d0527dd4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0527dd4",
  null
  
)

export default component.exports